import { render, staticRenderFns } from "./AdminProvidersList.vue?vue&type=template&id=17207714&scoped=true&"
import script from "./AdminProvidersList.vue?vue&type=script&lang=ts&"
export * from "./AdminProvidersList.vue?vue&type=script&lang=ts&"
import style0 from "./AdminProvidersList.vue?vue&type=style&index=0&id=17207714&lang=scss&scoped=true&"
import style1 from "./AdminProvidersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17207714",
  null
  
)

export default component.exports